import React from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

// No Route
import NoRoute from './NoRoute'

import B2bAccounts from './B2bAccounts'
// import B2bUsersIndex from './B2bUsersIndex'
// import BuserEdit from './BuserEdit'
// import BuserNew from './BuserNew'
import BusinessEdit from './BusinessEdit'
import BusinessesIndex from './BusinessesIndex'
import BusinessNew from './BusinessNew'
import BusinessProspectsIndex from './BusinessProspectsIndex'
import BusinessRedirect from './BusinessRedirect'
import CouponBusinessRedirect from './CouponBusinessRedirect'
import CouponEdit from './CouponEdit'
import CouponNew from './CouponNew'
import CouponRedirect from './CouponRedirect'
import CouponsIndex from './CouponsIndex'
import FeedbackIndex from './FeedbackIndex'
import Forgot from './Forgot'
import Login from './Login'
import PasswordCreated from './PasswordCreated'
import PaymentsIndex from './PaymentsIndex'
import ProfileEdit from './ProfileEdit'
import ProspectsIndex from './ProspectsIndex'
import QuestionForm from './QuestionForm'
import QuestionResults from './QuestionResults'
import QuestionsIndex from './QuestionsIndex'
import ResetPassword from './ResetPassword'
import Settings from './Settings'
import SystemUsers from './SystemUsers'
import TemplateForm from './TemplateForm'
import TemplateRedirect from './TemplateRedirect'
import TemplateResults from './TemplateResults'
import TemplatesIndex from './TemplatesIndex'
import TestsIndex from './TestsIndex'
import TestTakers from './TestTakers'
import UserConfirm from './UserConfirm'
import UserEdit from './UserEdit'
import UserNew from './UserNew'
import UserPurchasesRedirect from './UserPurchasesRedirect'
import UserQuestionsRedirect from './UserQuestionsRedirect'
import UserRedirect from './UserRedirect'
import VoucherBusinessRedirect from './VoucherBusinessRedirect'
import VoucherNew from './VoucherNew'
import VouchersIndex from './VouchersIndex'

import { validateToken } from '../actions/'

const mapStateToProps = state => {
  return {}
}

const mapDispatchToProps = dispatch => {
  return {
    validateToken: () => dispatch(validateToken()),
  };
};

class RouteProvider extends React.Component {
  componentWillMount() {
    if (this.props.loggedOn) {
      document.body.style.backgroundColor = "#f1f1f1"
    } else {
      document.body.style.background = "none"
    }
  }
  //
  // componentWillUnmount() {
  // }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.loggedOn !== prevProps.loggedOn) {
      if (this.props.loggedOn) {
        document.body.style.backgroundColor = "#f1f1f1"
      } else {
        document.body.style.background = "none"
      }
    }
  }

  changePath() {
    this.props.validateToken()
  }

  render() {
    const {mainComp, history} = this.props

    history.listen((location, action) => {
      this.changePath()
    });

    return (
        <Switch>
          <Route exact path="/" component={mainComp} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/reset_password" component={Forgot} />
          <Route exact path="/new_password/:reset_password_token" component={ResetPassword} />
          <Route exact path="/questions/new" component={QuestionForm} />
          <Route exact path="/questions/results" component={QuestionResults} />
          <Route exact path="/questions/:question_id/edit" component={QuestionForm} />
          <Route exact path="/questions" component={QuestionsIndex} />
          <Route exact path="/profile/edit" component={ProfileEdit} />
          <Route exact path="/settings" component={Settings} />
          <Route exact path="/templates/new" component={TemplateForm} />
          <Route exact path="/templates/results" component={TemplateResults} />
          <Route exact path="/templates/:template_id/edit" component={TemplateForm} />
          <Route exact path="/templates" component={TemplatesIndex} />
          <Route exact path="/purchases" component={PaymentsIndex} />
          <Route exact path="/pass" component={PasswordCreated} />
          <Route exact path="/feedback" component={FeedbackIndex} />
          <Route exact path="/system_users" component={SystemUsers} />
          <Route exact path="/test_takers" component={TestTakers} />
          <Route exact path="/b2busers" component={B2bAccounts} />
          <Route exact path="/coupons" component={CouponsIndex} />
          <Route exact path="/coupons/business" component={CouponBusinessRedirect} />
          <Route exact path="/coupons/new" component={CouponNew} />
          <Route exact path="/coupons/:coupon_id/edit" component={CouponEdit} />
          <Route exact path="/tests" component={TestsIndex} />
          <Route exact path="/users/:user_id/edit" component={UserEdit} />
          <Route exact path="/users/new" component={UserNew} />
          <Route exact path="/tests/template" component={TemplateRedirect} />
          <Route exact path="/tests/coupon" component={CouponRedirect} />
          <Route exact path="/tests/user" component={UserRedirect} />
          <Route exact path="/tests/test" component={UserRedirect} />
          <Route exact path="/activate/:token" component={UserConfirm} />
          <Route exact path="/questions/user" component={UserQuestionsRedirect} />
          <Route exact path="/purchases/user" component={UserPurchasesRedirect} />
          <Route exact path="/prospects" component={ProspectsIndex} />
          <Route exact path="/businesses" component={BusinessesIndex} />
          <Route exact path="/businesses/new" component={BusinessNew} />
          <Route exact path="/businesses/:business_id/edit" component={BusinessEdit} />
          <Route exact path="/b2bprospects" component={BusinessProspectsIndex} />
          <Route exact path="/users/business" component={BusinessRedirect} />
          <Route exact path="/vouchers/business" component={VoucherBusinessRedirect} />
          <Route exact path="/vouchers/new" component={VoucherNew} />
          <Route exact path="/vouchers" component={VouchersIndex} />

          <Route path="*" component={NoRoute} />


        </Switch>
    )
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RouteProvider))



// WEBPACK FOOTER //
// ./src/js/components/RouteProvider.js